/**
 * 查询参数工具函数
 */

export default {
  parse (search) {
    search = search || window.location.search
    const query = {}
    if (search) {
      search = search.trim().replace(/^\?/, '')
      search.split('&').forEach(param => {
        const parts = param.split('=')
        query[parts[0]] = parts[1] ? decodeURIComponent(parts[1]) : null
      })
    }
    return query
  }
}



// WEBPACK FOOTER //
// ./src/utils/query.js